export const isSameDay = (date1: Date): boolean => {
  const today = new Date();
  return (
    date1.getDate() === today.getDate() &&
    date1.getMonth() === today.getMonth() &&
    date1.getFullYear() === today.getFullYear()
  );
};

export const formatTime = (time: string): string => {
  if (!time) return '';

  const [hoursStr, minutes] = time.split(':');

  if (!hoursStr || !minutes) return '';

  const hours = +hoursStr % 24;

  const period = hours >= 12 ? 'pm' : 'am';

  const twelveHourFormat = hours % 12;

  const displayHours = twelveHourFormat === 0 ? 12 : twelveHourFormat;

  if (minutes === '00') {
    return `${displayHours}${period}`;
  }

  return `${displayHours}:${minutes}${period}`;
};

export const getMinutesUntil = (isoDate: string, now: Date = new Date()): number => {
  const target = new Date(isoDate);
  return Math.max(0, Math.ceil((target.getTime() - now.getTime()) / 60_000));
};

export const formatPreorderTime = (
  isoDate: string,
  timezone: string,
  locale?: string
): { isSameDay: boolean; preorderTime: string; dayName: string } => {
  const preorderDate = new Date(isoDate);
  const localeList = locale ? [locale] : undefined;
  const preorderTime = preorderDate.toLocaleTimeString(localeList, { hour: '2-digit', minute: '2-digit', timeZone: timezone });
  const dayName = preorderDate.toLocaleDateString(localeList, { weekday: 'long', timeZone: timezone });

  return {
    isSameDay: isSameDay(preorderDate),
    preorderTime,
    dayName,
  };
};
